import { makeActionCreator } from '../../config/store/utils';
import { batch } from 'react-redux';
import { getTimes, getTimesGroup } from '../../services/timesService';

/* --------- TIMES --------- */
export const GET_TIMES = 'GET_TIMES';
export const GET_TIMES_ERROR = 'GET_TIMES_ERROR';
export const GET_TIMES_SUCCESS = 'GET_TIMES_SUCCESS';

export const onGetTimes = makeActionCreator(GET_TIMES);
export const onGetTimesError = makeActionCreator(GET_TIMES_ERROR, 'payload');
export const onGetTimesSuccess = makeActionCreator(
  GET_TIMES_SUCCESS,
  'payload'
);

export const onGetTimesThunk = (date, turno) => async dispatch => {
  dispatch(onGetTimes());
  try {
    const endpointParams =
      date && turno
        ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear(),
            turno,
          }
        : null;

    if (!endpointParams) throw new Error('Faltan parámetros');

    const { data } = await getTimes(endpointParams);
    console.log(data);
    const ciclos = data;
    return batch(() => dispatch(onGetTimesSuccess({ data: ciclos })));
  } catch (error) {
    return batch(() => dispatch(onGetTimesError({ error })));
  }
};

/* --------- TIMES GROUP --------- */
export const GET_TIMES_GROUP = 'GET_TIMES_GROUP';
export const GET_TIMES_GROUP_ERROR = 'GET_TIMES_GROUP_ERROR';
export const GET_TIMES_GROUP_SUCCESS = 'GET_TIMES_GROUP_SUCCESS';

export const onGetTimesGroup = makeActionCreator(GET_TIMES_GROUP);
export const onGetTimesGroupError = makeActionCreator(GET_TIMES_GROUP_ERROR, 'payload');
export const onGetTimesGroupSuccess = makeActionCreator(
  GET_TIMES_GROUP_SUCCESS,
  'payload'
);

export const onGetTimesGroupThunk = (date, date_2) => async dispatch => {
  dispatch(onGetTimesGroup());
  try {
    const endpointParams =
      date && date_2
        ? {
            start_date: date,
            end_date: date_2,
          }
        : null;

    if (!endpointParams) throw new Error('Faltan parámetros');

    const { data } = await getTimesGroup(endpointParams);
    console.log(data);
    const ciclos = data;
    return batch(() => dispatch(onGetTimesGroupSuccess({ data: ciclos })));
  } catch (error) {
    return batch(() => dispatch(onGetTimesGroupError({ error })));
  }
};